export const PREFERENCES = {
  SIMPLE_FORMS: 'preference-simple-forms',
  MODEL_DEFAULT_MAINTENANCE_TYPE: 'model-default-maintenance-type',
  MODEL_DEFAULT_MAINTENANCE_NATURE: 'model-default-maintenance-nature',
  MODEL_DEFAULT_MAINTENANCE_STATUS: 'model-default-maintenance-status',
}
